import { useContext } from "react";
import { ThemeContext } from "../../../../context/theme-context";
import { CustomTheme } from "../../../../types/custom-theme";
import { ToolDescription, ToolsContainer } from "../styles";
import { ColorSelector } from "./selectors/color-selector";

export const Branding = () => {
  const {
    customTheme,
    setDataTheme,
  }: {
    customTheme: CustomTheme;
    setDataTheme: (path: string, value: string) => void;
  } = useContext(ThemeContext);

  const handleChangePrimaryColor = (color: string) => {
    setDataTheme("payment_form.button.background_color", color);
    setDataTheme("branding.primary", color);
  };

  return (
    <ToolsContainer>
      <ToolDescription>
        Boost your brand with your logo and signature colors.
      </ToolDescription>

      <ColorSelector
        color={customTheme.payment_form.button.background_color}
        label={"Primary color"}
        noMargin
        onChange={handleChangePrimaryColor}
      />
    </ToolsContainer>
  );
};
